import React from 'react';
import { Stack } from '@mui/material';
import { StatusChip } from 'src/UIKit';
import { statusChipSx } from '../../../../helpers';

interface StatusChipsProps {
  status?: string;
  identityStatus?: string;
}

export const StatusChips: React.FC<StatusChipsProps> = ({ status, identityStatus }) => {
  if (!status && !identityStatus) {
    return null;
  }

  return (
    <Stack direction="row" gap={0.5} mr={1}>
      {status && (
        <StatusChip
          label={status}
          color={status === 'ACTIVE' ? 'success' : 'default'}
          variant="outlined"
          sx={statusChipSx}
        />
      )}
      {identityStatus && (
        <StatusChip
          label={identityStatus}
          color={identityStatus === 'VERIFIED' ? 'success' : 'warning'}
          variant="outlined"
          sx={statusChipSx}
        />
      )}
    </Stack>
  );
};
